import { Outlet, Link } from 'react-router-dom';
import { Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function AuthLayout() {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen flex">
            {/* Left side - Branding */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-secondary-600 p-12 flex-col justify-between">
                <div className="flex items-center">
                    <div className="flex items-center gap-3 text-white">
                        <Target className="w-10 h-10" />
                        <span className="text-2xl font-bold">VisionBoard</span>
                    </div>
                </div>

                <div className="text-white">
                    <h1 className="text-4xl font-bold mb-4">
                        {t('landing.hero.title')}
                    </h1>
                    <p className="text-lg text-white/80">
                        {t('landing.hero.subtitle')}
                    </p>
                </div>

                <div className="flex items-center gap-8 text-white/60 text-sm">
                    <span>{t('landing.footer.copyright')}</span>
                    <Link to="/privacy" className="hover:text-white">Bảo mật</Link>
                    <Link to="/terms" className="hover:text-white">Điều khoản</Link>
                </div>
            </div>

            {/* Right side - Auth Form */}
            <div className="flex-1 flex flex-col">
                <div className="flex-1 flex items-center justify-center p-8">
                    <div className="w-full max-w-md">
                        {/* Mobile logo */}
                        <div className="lg:hidden flex items-center justify-center gap-2 mb-8">
                            <Target className="w-8 h-8 text-primary-600" />
                            <span className="text-xl font-bold gradient-text">VisionBoard</span>
                        </div>

                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}
